import React, { useEffect, useState } from "react";
import Header from "./header/header";
import Headerwithicon from "./header/headerWithIcon";

import FloatingVideoChatWindow from "./FloatingVideoChatWindow";
import useAgora from "../../videochat/hooks/useVideoChat";

import Sidebar from "./sidebar/sidebar";
import SiteHome from "./contentBody/siteHome";

const MainPage = (props) => {
  const location = props.location;
  const [channel, setChannel] = useState(null);
  const {
    client,
    localAudioTrack,
    localVideoTrack,
    remoteUsers,
    joinState,
    isMinimized,
    setIsMinimized,
    leave,
    screenshare,
    error,
    callAgoraCred,
  } = useAgora(channel);

  useEffect(() => {
    setChannel(JSON.parse(localStorage.getItem("channel_id")));
  }, []);

  const removeSidebar = ["/activateContact", "/activatePatient"];

  useEffect(() => {
    if (window.location.pathname !== `/site/site/${channel}/video`) {
      setIsMinimized(true);
      if (channel) {
        callAgoraCred();
      }
    } else {
      setIsMinimized(false);
    }
  }, [channel]);

  const handleMaximize = () => {
    window.location.href = `/site/site/${channel}/video`;
    setIsMinimized(false);
  };

  return (
    <>
      <div id="wrapper">
        {isMinimized && localVideoTrack ? (
          <FloatingVideoChatWindow
            localTrack={localVideoTrack}
            remoteUsers={remoteUsers}
            onMaximize={handleMaximize}
            onClose={() => {
              setIsMinimized(false);
              leave();
            }}
          />
        ) : null}
        {!removeSidebar.includes(location.pathname) && <Sidebar />}
        <div className="contentBody">
          {removeSidebar.includes(location.pathname) ? (
            <Headerwithicon />
          ) : (
            <Header />
          )}
          <SiteHome />
        </div>
      </div>
    </>
  );
};
export default MainPage;
